/**
 * Префиксы для сохранения в localStorage
 */

/**
 * Опциональные колонки
 */
export enum ColsStorage {
  LEADS = 'leads_cols',
  ORDERS = 'orders_cols',
  ORDERS_INVOICES = 'orders_invoices_cols',
  ORDER_DETAILS_INFO = 'order_details_info_cols',
  STAFFS = 'staffs_cols',
  STAFFS_CERTIFICATES_LIST = 'courses-list',
  ORGANIZATIONS = 'organizations_cols',
  ORGANIZATIONS_DETAIL_CONTRACTS = 'organizations_detail_contracts_cols',
  SUBPARTNERS = 'subpartners_cols',
  SUBPARTNERS_SALES = 'subpartner_sales_cols',
  CLIENTS = 'clients_cols',
  REPAIR_LIST = 'repair_list_cols',
  REPAIR_DETAIL_PRODUCTS = 'repair_detail_products_cols',
  REPAIR_REPORTS_ORDER_LIST = 'repair_reports_order_list_cols',
  REPAIR_REPORTS_ZIP_LIST = 'repair_reports_zip_list_cols',
  DISPATCHES = 'dispatches_cols',
  MARKETING_FUND_APLICATIONS_LIST = 'marketing_fund_aplications_list',
  MARKETING_FUND_EVENTS_LIST = 'marketing_fund_events_list',
  CATALOG = 'catalog_cols',
  RETURN_ZIPS = 'return_zips_cols',
  CART_HISTORY = 'cart-history_cols',
  CART_DETAIL_ORDERS_LIST = 'cart-detail_orders_list_cols',
  PARTNER_COMPANY_SALE_POINT = 'partner_company_sale_point_cols',
  PARTNER_COMPANY_SERVICE_CENTERS = 'partner_company_service_centers_cols',
  MARKETING_FUND_APLICATIONS_EVENTS = 'marketing_fund_aplications_events_cols',
  MARKETING_FUND_APLICATIONS_HISTORY = 'marketing_fund_aplications_history_cols',
  MARKETING_FUND_EVENTS_HISTORY = 'marketing_fund_events_history_cols',
  REPORTS_ORDERS_SHIPPED = 'reports_orders_shipped_cols',
  REPORTS_ORDERS_NOT_SHIPPED = 'reports_orders_not_shipped_cols',
  REPORTS_ORDERS_READY = 'reports_orders_ready_cols',
  REPORTS_SALES_PLAN_FACT = 'reports_sales_plan_fact_cols',
  REPORTS_SALES_MONEY_PLAN_FACT = 'reports_sales_money_plan_fact_cols',
  REPORTS_SERVICE = 'reports_service_cols',
  REPORTS_MUTUAL = 'reports_mutual_cols',
  REPORTS_ORDERS_CANCELED = 'reports_orders_canceled_cols',
  PROJECTS_COLS = 'projects_cols',
  PROJECT_DETAIL_PRODUCTS_COLS = 'project_detail_products_cols',
  PROJECT_DETAIL_ADDITIONAL_PARK_COLS = 'project_detail_additional_park_cols',
  PROJECT_DETAIL_ADDITIONAL_COMPETITORS_COLS = 'project_detail_additional_competitors_cols',
  PROJECT_DETAIL_HISTORY_COLS = 'project_detail_history_cols',
  PROJECT_DETAIL_DOCUMENTS_COLS = 'project_detail_documents_cols',
  NEW_PROJECT_COLS = 'new_project_cols',
  COURSES_REQUESTS = 'courses_cols',
  SOFTWARE_LICENSES = 'software_licenses_cols',
  NOT_ACTIVE_SOFTWARE_LICENSES = 'not_active_software_licenses_cols',
  SOFTWARE_LICENSES_DETAILS = 'software_licenses_details_cols',
  WEBHOOK_LOGS = 'webhook_logs_cols',
  CANCELED_PRODUCTS = 'canceled_products_cols',
  CONFERENCES_COLS = 'conferences_cols',
  COMMERCIAL_OFFERS = 'commercial_offers_cols',
  COMMERCIAL_OFFERS_TEMPLATES = 'commercial_offers_templates',
  PURCHASE_ORDERS = 'purchase_orders_cols',
  DATA_PILOT = 'data_pilot_cols',
  DATA_PILOT_REASONS_COMMUNICATION = 'data_pilot_reasons_communication_cols',
  DATA_PILOT_PRODUCTS = 'data_pilot_products_cols',
  DATA_PILOT_EVENT_HISTORY = 'data_pilot_event_history_cols',
  CLIENT_CONTACTS = 'client_contacts_cols',
  LOANS = 'loans_cols',
}

/**
 * Поля "заполните данные" при оформлении заказа
 */
export enum OrderFields {
  ORDER_CART = 'order_cart_fields'
}

export enum OrderCartFields {
  ORDER_CART = 'default_new_order'
}

export enum PaginationItemsPerPage {
  CERTIFICATES = 'at_certificates_items-per-page',
  COURSES_REQUESTS = 'at_courses-requests_items-per-page',
  COURSES_REQUEST_REQUESTED_COURSES = 'at_courses-request_requested-courses_items-per-page',
  COURSES_REQUEST_REQUESTED_STAFFS = 'at_courses-request_requested-staffs_items-per-page',
  COURSES_REQUEST_HISTORY = 'at_courses-request_history_items-per-page',
  COMMERCIAL_OFFERS = 'at_commercial-offers_items-per-page',
  COMMERCIAL_OFFERS_TEMPLATES = 'at_commercial-offers-templates_items-per-page',
  COMMERCIAL_OFFER_PRODUCTS = 'at_commercial-offer_products_items-per-page',
  COMMERCIAL_OFFER_PARTNER_PRODUCTS = 'at_commercial-offer_partner-products_items-per-page',
  MARKETING_FUND_REQUESTS = 'at_marketing-fund-requests_items-per-page',
  MARKETING_FUND_REQUEST_EVENTS = 'at_marketing-fund-request_events_items-per-page',
  MARKETING_FUND_REQUEST_HISTORY = 'at_marketing-fund-request_history_items-per-page',
  MARKETING_FUND_EVENTS = 'at_marketing-fund-events_items-per-page',
  CONFERENCES = 'at_conferences_items-per-page',
  COMPANY_CLIENTS = 'at_company_clients_items-per-page',
  COMPANY_STAFFS = 'at_company_staffs_items-per-page',
  COMPANY_WEBHOOK_LOGS = 'at_company_webhook-logs_items-per-page',
  ORGANIZATION_CASH_REGISTERS = 'at_organization_cash-registers_items-per-page',
  ORGANIZATION_VALIDATION_BLACK_LIST = 'at_organization-validation_black-list_items-per-page',
  COMPANY_SUBPARTNERS = 'at_company_subpartners_items-per-page',
  COMPANY_SUBPARTNERS_SALES = 'at_company_subpartners-sales_items-per-page',
  PRODUCTS = 'at_products_items-per-page',
  CART_HISTORY = 'at_cart-history_items-per-page',
  LEADS = 'at_leads_items-per-page',
  ORDERS = 'at_orders_items-per-page',
  DISPATCHES = 'at_dispatches_items-per-page',
  ORDERS_INVOICES = 'at_orders_invoices_items-per-page',
  PROJECTS = 'at_projects_items-per-page',
  PROJECT_PRODUCTS = 'at_project_products_items-per-page',
  PROJECT_EQUIPMENTS = 'at_project_equipments_items-per-page',
  PROJECT_COMPETITORS = 'at_project_competitors_items-per-page',
  PROJECT_HISTORY = 'at_project_history_items-per-page',
  PROJECT_REALIZATIONS = 'at_project_realizations_items-per-page',
  SOFTWARE_LICENSES = 'at_software-licenses_items-per-page',
  NOT_ACTIVE_SOFTWARE_LICENSES = 'at_not_active_software_licenses_items-per-page',
  SOFTWARE_LICENSES_HISTORY = 'at_software-licenses-history_items-per-page',
  SOFTWARE_CART_HISTORY = 'at_software-cart-history_items-per-page',
  REPORT_CANCELED_PRODUCTS = 'at_report_canceled-products_items-per-page',
  REPORT_NOT_SHIPPED_PRODUCTS = 'at_report_not-shipped-products_items-per-page',
  REPORT_READY_SHIPMENT = 'at_report_ready-shipment_items-per-page',
  REPORT_SHIPPED_PRODUCTS = 'at_report_shipped-products_items-per-page',
  REPORT_PLAN = 'at_report_plan_items-per-page',
  REPORT_MONEY_PLAN_FACT = 'at_report_money_plan_fact_items-per-page',
  REPORT_SERVICE = 'at_report_service_items-per-page',
  REPORT_MUTUAL_DETAIL = 'at_report_mutual-detail_items-per-page',
  NOTIFICATIONS = 'at_notifications_items-per-page',
  COMPANIES_USERS_MANAGERS = 'at_companies_users_managers_items-per-page',
  COMPANIES_USER_STAFF = 'at_companies_user_staff_items-per-page',
  REPAIRS = 'at_repairs_items-per-page',
  REPAIR_PRODUCTS = 'at_repair_products_items-per-page',
  REPAIR_RETURN_ZIPS = 'at_repair_return-zips_items-per-page',
  RETRO_BONUSES = 'at_retro_bonuses_items-per-page',
  REWARD_DOCUMENT_DETAIL = 'at_reward_document_detail_items-per-page',
  REWARD_DOCUMENTS = 'at_reward_documents_items-per-page',
  PURCHASE_ORDERS = 'at_purchase_orders_items-per-page',
  DATA_PILOT = 'at_data_pilot_items-per-page',
  DATA_PILOT_REASONS_COMMUNICATION = 'at_data_pilot_reasons_communication_items-per-page',
  DATA_PILOT_PRODUCTS = 'at_data_pilot_products_items-per-page',
  DATA_PILOT_EVENT_HISTORY = 'at_data_pilot_event_history_items-per-page',
  LOANS = 'at_loans_items-per-page',
}
